export const cilArrowThickToBottom = ["24 24","<path d='M15.75 8.25v-7.5h-7.5v7.5h-5.625v1.81l9.366 9.375 9.384-9.375v-1.811zM11.992 17.314l-7.557-7.564h5.315v-7.5h4.5v7.5h5.314z'></path><path d='M2.625 21.75h18.75v1.5h-18.75v-1.5z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-arrow-thick-to-bottom.js
// module id = null
// module chunks = 